import * as React from 'react';
import { useState } from 'react';
import Parser from 'html-react-parser';

import {
    Backdrop,
    Box,
    Button,
    Modal,
    Typography,
    Stack,
    ButtonBase,
} from "@mui/material";

export default function ModalConfirmar(props) {
    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            {!props.envuelveBoton ? (
                props.useDiv ? (
                    <span onClick={handleOpen}>{props.children}</span>
                ) : (
                    <ButtonBase onClick={handleOpen}>{props.children}</ButtonBase> //Envuelve el hijo conviertiendolo en boton
                )
            ) : (props.children)}
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby='modal-title'
                aria-describedby='modal-description'
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 200,
                }}
            >
                <Box sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: {xs: "80vw", md: "auto"},
                    bgcolor: "background.paper",
                    boxShadow: 24,
                    borderRadius: 2,
                    p: 4,
                }}>
                    <Stack spacing={2}>
                        <Typography
                            id="transition-modal-title"
                            variant="h6"
                            sx={{ fontWeight: 'bold' }}
                        >
                            {Parser(props.title)}
                        </Typography>
                        <Typography
                            id="transition-modal-description"
                            textAlign={"justify"}
                            sx={{ mt: 2 }}
                        >
                            {Parser(props.text)}
                        </Typography>
                    </Stack>
                    <Stack
                        direction={"row"}
                        spacing={2}
                        marginTop={3}
                        justifyContent={"space-between"}
                    >
                        <Button onClick={handleClose} variant="contained">
                            {props.cancelText}
                        </Button>
                        {props.onContinue && (
                            <Button onClick={props.onContinue} variant="contained">
                                {props.continueText}
                            </Button>
                        )}
                    </Stack>

                </Box>
            </Modal>
        </>
    );
}
